import { Component, ElementRef, ViewChild, OnInit, Compiler} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import 'rxjs/add/operator/filter';
import { GridOptions } from "ag-grid";
import { ConsigmentUploadService } from 'app/d2z/service/consignment-upload.service';
import { TrackingDataService } from 'app/d2z/service/tracking-data.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';

declare var $: any;

@Component({
  selector: 'd2z-driver-allocation',
  templateUrl: './driver-allocation.component.html',
  styleUrls: ['./driver-allocation.component.css']
})
export class DriverAllocationComponent implements OnInit{
  driverAllocationForm: FormGroup;
  childmenu: boolean;
  childmenuTwo:boolean;
  childmenuThree:boolean;
  childmenuFour:boolean;
  childmenuFive:boolean;
  manifestNumber: string;
  errorMsg: string;
  successMsg: String;
  show: Boolean;
  userName: String;
  role_id: String;
 
  constructor(
    public consigmentUploadService: ConsigmentUploadService,
    public trackingDataService : TrackingDataService,
    private spinner: NgxSpinnerService,
    private _compiler: Compiler
  ) {
    this.show = false;
    this._compiler.clearCache();
    this.driverAllocationForm = new FormGroup({
      referenceNumber: new FormControl()
      });
  }

  ngOnInit() {
      this.getLoginDetails();
  };

  getLoginDetails(){
    if(this.consigmentUploadService.userMessage != undefined){
      this.userName = this.consigmentUploadService.userMessage.userName;
      this.role_id = this.consigmentUploadService.userMessage.role_Id;
    }
  };

  supplierData(){
    this.errorMsg = null;
    this.successMsg = null;
   
    if(this.driverAllocationForm.value.referenceNumber == null || this.driverAllocationForm.value.referenceNumber == ''){
      this.errorMsg = "**Please Enter the Reference Number";
    }
    if(this.errorMsg == null ){
      var referenceNumberData = this.driverAllocationForm.value.referenceNumber.split("\n");
      var refrenceNumList = [];
      for (var labelValue in referenceNumberData) {
            var labelObj = referenceNumberData[labelValue];
           
            refrenceNumList.push(labelObj)
      }
      console.log(refrenceNumList);
     // var refrenceNumList = referenceNumberData.join(',');
        this.spinner.show();
         
        this.trackingDataService.remapTransvirtual(refrenceNumList,30, (resp) => {
          this.spinner.hide();
          if(resp.error){
            this.errorMsg = resp.error.errorDetails;
          }else{
            this.successMsg = 'Data sent Successfully';
            this.driverAllocationForm.reset();
        }
          setTimeout(() => {
            this.spinner.hide();
          }, 5000);
        });
    }
  }

  
  downloadReport(resp){
        
   
    if(resp.length > 0 ){
        var currentTime = new Date();
        var consignmentList = [];
        var fileName = '';
            fileName = "DriverAllocationManifest"+"-"+currentTime.toLocaleDateString();
          var options = { 
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true, 
            useBom: true,
            headers: [ 
              "Address Name/Flat/Unit Number",
              "Address Line 1",
              "City",
              "State",
              "Zip",
              "Country",
              "Notes",
              "Recipient Name",
              "Recipient Phone Number",
              "Id",
              "Package Count"
            ]
          };
          let addressName = 'addressName';
          let address1='address1';
          let city='city';
          let state='state';
          let zip='zip';
          let country='country';
          let recipientName='recipientName';
          let phone = 'phone';
          let referenceNumber ='referenceNumber';
          let count='count';
          let notes='notes';

          for (var val in resp) {
              var data = resp[val];
              var importObj = (
                  importObj={},
                  importObj[addressName]= '', importObj,
                  importObj[address1]= data != null ? data.address1: '', importObj,                
                  importObj[city]= data != null ? data.city: '', importObj,
                  importObj[state]= data != null ? data.state: '', importObj,                
                  importObj[zip]= data != null ? data.zip: '', importObj,                
                  importObj[country]= data != null ? data.country: '', importObj,
                  importObj[notes]= '', importObj,
                  importObj[recipientName]= data != null ? data.recipientName: '', importObj,
                  importObj[phone]= data != null ? data.phone: '', importObj,
                  importObj[referenceNumber]= data != null ? data.referenceNumber: '', importObj,
                  importObj[count]= data != null ? data.count: '', importObj


                
              );
              consignmentList.push(importObj)
          }
        new Angular2Csv(consignmentList, fileName, options);  
       
      }else{
       
        this.errorMsg = "No records to download";
        
      } 
  }
  
 
}





// WEBPACK FOOTER //
// ./src/app/d2z/views/superuser-level/create-shipment/driver-allocation/driver-allocation.component.ts